'use client';
import { IProductDetail } from '@/api/types/public';
import Dialog from '@/components/Dialog';
import QuestionResponsive from '@/components/IconResponsive/QuestionResponsive';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useContext, useState } from 'react';
import GoodsDetailCollapse from './GoodsDetailCollapse';
// 从Vue代码中提取的getHtmlText函数
const getHtmlText = (html: string): string => {
  // 如果html是undefined或null，返回空字符串
  if (!html) return '';
  return html;
};

// 富文本样式
const richTextStyle = `
.product-included-content p {
  font-family: var(--font-instrument);
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 20px;
}
.product-included-content p:has(strong) {
  margin-bottom: 8px;
}
.product-included-content p:last-child {
  margin-bottom: 0;
}
.product-included-content strong {
  font-family: var(--font-bricolage-extrabold);
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
}
.product-included-content img {
  width: 100%;
  height: auto;
  display: block;
  margin-top: 24px;
  margin-bottom: 24px;
}
`;

interface ProductIncludedProps {
  detail: IProductDetail;
  SDProductDetailsPageBtnClick?: (btnName: string) => void;
  className?: string;
}

export default function ProductIncluded({
  detail,
  SDProductDetailsPageBtnClick,
  className = '',
}: ProductIncludedProps) {
  // 是否展示此模块（根据状态和数组长度判断）
  const isShow =
    detail?.product_content_guarantee?.status === 1 &&
    (detail?.product_content_guarantee?.values?.length ?? 0) > 0;
  const { deviceType } = useContext(ResponsiveContext);
  const [showDetailsPopup, setShowDetailsPopup] = useState(false);
  const [currentDetails, setCurrentDetails] = useState<string>('');
  const [currentTitle, setCurrentTitle] = useState<string>('');
  // 打开详情弹窗
  const openDetailsPopup = (inner_title?: string, details?: string) => {
    setCurrentTitle(inner_title || '');
    setCurrentDetails(details || '');
    setShowDetailsPopup(true);
  };

  // 关闭详情弹窗
  const closeDetailsPopup = () => {
    setShowDetailsPopup(false);
    setCurrentDetails('');
    setCurrentTitle('');
  };

  if (!isShow) {
    return null;
  }
  return (
    <>
      <GoodsDetailCollapse
        title={detail?.product_content_guarantee?.title}
        defaultOpen
        onChange={() => SDProductDetailsPageBtnClick?.('Services&Guarantees')}
      >
        <div
          className={`grid grid-cols-1 gap-[10px] ${
            deviceType === EPlatform.WEB ? 'pb-[24px]' : 'pb-[20px]'
          } ${className}`}
        >
          {detail.product_content_guarantee?.values.map((item, index) => (
            <div key={`${item.content}-${index}`} className="flex items-center relative">
              <div className="before:content-[''] before:absolute before:w-[4px] before:h-[4px] before:rounded-full before:bg-primary-text before:left-0 before:top-[50%] before:translate-y-[-50%] pl-16 text-[14px] leading-[1.3] flex items-center gap-4">
                {item.content && (
                  <span
                    className="flex-1"
                    dangerouslySetInnerHTML={{ __html: getHtmlText(item.content) }}
                  />
                )}
                {item.details && (
                  <QuestionResponsive
                    className="text-[16px] ml-[2px]"
                    onClick={(e: React.MouseEvent) => {
                      e.stopPropagation();
                      openDetailsPopup(item?.inner_title || '', item?.details || '');
                      SDProductDetailsPageBtnClick?.(item.content);
                    }}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </GoodsDetailCollapse>

      {/* 详情弹窗 */}
      <Dialog.Info open={showDetailsPopup} onClose={closeDetailsPopup} title={currentTitle}>
        <style dangerouslySetInnerHTML={{ __html: richTextStyle }} />
        <div className="box-border">
          <div
            className="product-included-content text-[14px] leading-[18px] font-ir"
            dangerouslySetInnerHTML={{ __html: getHtmlText(currentDetails) }}
          />
        </div>
      </Dialog.Info>
    </>
  );
}
